/** @jsx h */
import { h } from 'preact';
import styles from './style.css';
import translations from './translations';
import { TranslationHelper } from '../../js/TranslationHelper';

interface PositionConstraints {
  right: number;
  bottom: number;
  left: number;
}

interface Props extends Partial<PositionConstraints> {
  position?: string;
  locale?: Locale;
  watermarkApiKeys: Array<string>;
  apiKey?: string;
  [key: string]: any;
}

const i18n = new TranslationHelper({
  langs: {
    ...translations,
    default: translations['en']
  } as any
});

const createPositionStyles = ({
  right,
  bottom,
  left
}: PositionConstraints): Record<string, Record<string, number>> => ({
  'bottom-left': {
    bottom,
    left
  },
  'bottom-right': {
    bottom,
    right
  }
});

const getStyles = (
  position: string,
  positionConstraints: PositionConstraints
): Record<string, number> => {
  const positionStyles = createPositionStyles(positionConstraints);
  let styles = positionStyles['bottom-left'];

  if (positionStyles.hasOwnProperty(position)) {
    styles = positionStyles[position];
  }

  return styles;
};

const Watermark = ({
  position = 'bottom-left',
  right = 8,
  bottom = 8,
  left = 8,
  locale,
  watermarkApiKeys,
  apiKey,
  ...otherProps
}: Props) => {
  i18n.useLocale(locale);

  if (watermarkApiKeys.indexOf(apiKey || '') === -1) {
    return null;
  }

  return (
    <div
      data-zone="watermark"
      id="watermark"
      className={styles.container}
      style={getStyles(position, { right, bottom, left })}
      {...otherProps}
    >
      {i18n.get('title')}
    </div>
  );
};

export default Watermark;
